import React, { Component } from "react";

class About extends Component {
  render() {
    return (
      <div className="background-white">
        <div className="d-lg-flex">
          <div className="col-left">
            <div
              className="featured-post animate-element wow delay5 fadeInUp"
              data-wow-delay="0.5s"
            >
              <img src="/images/section/03.png" alt="images" />
            </div>
          </div>
          <div className="col-right">
            <div
              className="flat-spacer"
              data-desktop="105"
              data-mobile="50"
              data-smobile="50"
            ></div>
            <div className="flat-title t1">
              <div
                className="animate-element wow delay5 fadeInDown"
                data-wow-delay="0.5s"
              >
                <h4 className="sub-title mg-b22">About Me</h4>
                <h2 className="title-section mg-b26 color-d12">
                 Hi, I am Sara a passionate Junior web developer.
                 <h4 className="color-d4">My experience</h4>
                </h2>
                <p>
                 My very first experience with programming was 2 months with Avanade(Italy) as a Software and web developer as an Intern where I learned the fundamentals of SQL and C# and a quick introduction to HTML CSS javascript. It was like a mini Bootcamp sponsored by the company where all the students were required to solve coding challenges and build real-life scenario projects with deadlines.
                 Furthermore, I have recently graduated from an intensive coding Bootcamp with Just It; Is where I have learned the fundamentals of programming using HTML CSS JAVASCRIPT SQL PYTHON. As a result of this, I have built 4 unique projects. The details and code of the projects are in my portfolio section.
               
                </p>
                <p>
                I am currently volunteering for Hope shot for humanitarians' operations and working mainly on their
                front-end development side using API, CSS, HTML and REACT. 
                Additionally, I am working on their Backend api using .net fixing bugs and adding new features.
                </p>
              </div>
              <div
                className="animate-element wow delay5 fadeInUp"
                data-wow-delay="0.5s"
              >
                <div className="fl-btn btn-general">
                  <a
                    href="https://www.linkedin.com/in/sara-uras-11619a166/"
                    className="f-w500 color-1 lt-sp07"
                  >
                    Hire Me
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default About;
